import styled from "styled-components";
import { Box } from "rebass/styled-components";

import { SUGGESTED_REASON_CONFIG } from "../../Views/Homepage/SuggestedItem/reasonConfig";
import { AnimatedTooltip } from "../AnimatedTooltip";

interface IReasonIconProps {
  reason: string;
  showTooltip?: boolean;
}

const ReasonIcon = ({ reason, showTooltip = true }: IReasonIconProps) => {
  const suggestionItem =
    SUGGESTED_REASON_CONFIG[reason] || SUGGESTED_REASON_CONFIG["Unspecified"];
  const Icon = suggestionItem.icon;

  const iconElement = (
    <IconContainer
      gradient={suggestionItem.gradient}
      iconColor={suggestionItem.iconColor}
    >
      <Icon />
    </IconContainer>
  );

  if (!showTooltip) {
    return iconElement;
  }

  return (
    <AnimatedTooltip content={suggestionItem.display}>
      {iconElement}
    </AnimatedTooltip>
  );
};

const IconContainer = styled(Box)<{
  gradient: string;
  iconColor: string;
}>`
  width: 20px;
  height: 20px;
  border-radius: 3px;
  background: ${(props) => props.gradient};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  flex-shrink: 0;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  svg {
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
    width: 12px;
    height: 12px;
    color: ${(props) => props.iconColor};
    fill: ${(props) => props.iconColor};
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;

export { ReasonIcon };
export type { IReasonIconProps };
